import React, { useEffect, useState } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Script } from 'gatsby';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import useSelector from 'components/Booking-new/hooks';

import stepTypes from 'components/Booking-new/modules/Steps/types';

import getProperImageData from 'utils/getProperImageData';
import pushGTMWithDelay from 'utils/pushGTMWithDelay';
import { pushGTMAppointmentDetailsDisplayedEvent, types } from 'utils/gtm';

import NewsBanner, { BannerWrapper, shouldDisplayNewsBannerInBooking } from 'components/common/NewsBanner';
import { getServiceCode, getServiceData } from 'components/Booking-new/utils/steps/service';

import SummaryList from '../../shared/SummaryList';
import BookingSurvey from './components/BookingSurvey';
import PageComponents from './components/PageComponents';

import CalendarButton from './components/CalendarButton';

import { CalendarButtonsWrapper, ColumnSummary, StyledResultsWrapper, StyledImage } from './styles';

const VariantA = ({ data }) => {
  const { results } = useSelector(state => ({
    config: state?.config,
    stepLocationData: state?.userData[stepTypes.location]?.selectedLocation,
    stepTimeData: state?.userData[stepTypes.time],
    stepPersonalData: state?.userData[stepTypes.personalData],
    stepSummary: state?.userData?.[stepTypes.summary],
    rescheduleData: state?.userData[stepTypes.reschedule]?.appointment?.appointmentid,
    serviceCode: getServiceCode(state?.userData[stepTypes.reschedule]?.service.service, state?.config?.service?.code),
    serviceData:
      getServiceData(state?.services.nodes, state?.userData[stepTypes.reschedule]?.service.service) ||
      state?.config?.service,
    showNewsBanner: state?.config?.showNewsBanner,
    allServices: state?.services.nodes,
    funnelType: state?.config?.funnelType,
  }));
  const { config } = results;

  useEffect(() => {
    // trigger GTM event "Appointment Details Displayed"
    pushGTMWithDelay(33, pushGTMAppointmentDetailsDisplayedEvent, {
      type: results?.rescheduleData ? types.reschedule : types.book,
      location: results?.stepLocationData.code,
      service: results?.serviceCode,
      funnelType: results?.funnelType,
    });
  }, []);

  const newsBannerVisible = shouldDisplayNewsBannerInBooking(data?.newsBanner, results?.showNewsBanner);
  const properImage = getProperImageData(data?.localImage) || data?.image;

  const [showCES, setShowCES] = useState(false);

  return (
    <div>
      {data?.surveyAfterBooking && (
        <BookingSurvey showCES={showCES} setShowCES={setShowCES} data={data.surveyAfterBooking} />
      )}
      {showCES && data?.typeformLiveId && (
        <>
          <Script
            src={`//embed.typeform.com/next/embed.js`}
            onError={error => {
              console.log('typeform loading error.', error);
            }}
          />
          <div
            data-tf-live={data?.typeformLiveId}
            data-tf-hidden={`appointment_id=${results.stepSummary.appointmentid},user_id=${results.stepSummary.userid}, touchpoint=CES_after_booking,feedback_type=CES`}
            data-tf-hide-footer={true}
            data-tf-height={'100%'}
          ></div>
        </>
      )}

      {newsBannerVisible && (
        <BannerWrapper>
          <NewsBanner newsBanner={data?.newsBanner} overWriteBackColor={true} />
        </BannerWrapper>
      )}
      <StyledResultsWrapper>
        <div>
          <StyledImage>
            {properImage?.gatsbyImageData && (
              <GatsbyImage
                image={properImage.gatsbyImageData}
                alt={properImage.title}
                loading="eager"
                imgStyle={{ objectPosition: 'left' }}
              />
            )}
          </StyledImage>
          <ColumnSummary>
            <Typography component="h1" variant="DS_h3" data-test="booking-summary-title">
              {data.title}
            </Typography>
            <SummaryList {...results} serviceName={results.serviceData.name} />
            <CalendarButtonsWrapper>
              {data?.googleButtonLabel && (
                <CalendarButton
                  userData={results}
                  label={data.googleButtonLabel}
                  type="google"
                  serviceName={config.service?.name}
                  testAttributes="booking-summary-google-calendar"
                />
              )}
              {data?.iCalButtonLabel && (
                <CalendarButton
                  userData={results}
                  serviceName={config.service?.name}
                  type="default"
                  label={data.iCalButtonLabel}
                  testAttributes="booking-summary-ical-calendar"
                />
              )}
            </CalendarButtonsWrapper>
          </ColumnSummary>
        </div>
      </StyledResultsWrapper>
      {data?.body && <PageComponents body={data?.body} />}
    </div>
  );
};
VariantA.propTypes = {
  data: PropTypes.shape({
    newsBanner: PropTypes.object,
    image: PropTypes.object,
    localImage: PropTypes.object,
    surveyAfterBooking: PropTypes.object,
    googleButtonLabel: PropTypes.string,
    iCalButtonLabel: PropTypes.string,
    body: PropTypes.array,
  }),
};

export default VariantA;
